import React, { PropTypes, Component } from 'react'

import './UserServices.scss'
import ServicesNavbar from './components/ServicesNavbar'

class UserServices extends Component {
  componentDidMount () {
    this.props.updateTitle('Servicios')
  }

  render () {
    const {
      children,
      userId
    } = this.props

    return (
      <div className='UserServices'>
        <ServicesNavbar userId={userId} />
        { children }
      </div>
    )
  }
}

UserServices.displayName = 'UserServices'
UserServices.propTypes = {
  updateTitle: PropTypes.func,
  children: PropTypes.node,
  userId: PropTypes.string.isRequired
}
UserServices.defaultProps = {
  updateTitle: () => {}
}

export default UserServices



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/UserServices.js